<template>
  <button class="base-button">
    <img src="@/assets/icons/EditDark.svg" alt="" class="icon-edit" />
  </button>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EditButton",
});
</script>

<style scoped lang="scss">
@import "src/styles/commons/controls/editButton";
</style>
